import * as FileDownload from "js-file-download";
export const fileDownload: Function = FileDownload as any;

export function fileOpen(fileBlob: Blob) {
	const blobURL = URL.createObjectURL(fileBlob);
	window.open(blobURL);
}
